export default "__VITE_ASSET__3714c74e__"